import { SortItem } from '../ss-api/responses/member.dashboard.license.response';

interface RegistrySubKeyItem {
    KeyName: string;
}

interface RegistryValueItem {
    ValueName: string;
    Value: string;
    ValueKind: string;
    Editable: boolean;
}

export class RegistrySubKeyItemArray extends Array<RegistrySubKeyItem> {
    public LastSort = new SortItem;

    constructor(...items: RegistrySubKeyItem[]) {
        super(...items);
        Object.setPrototypeOf(this, RegistrySubKeyItemArray.prototype);
    }
}

export class RegistryValueItemArray extends Array<RegistryValueItem> {
    public LastSort = new SortItem;

    constructor(...items: RegistryValueItem[]) {
        super(...items);
        Object.setPrototypeOf(this, RegistryValueItemArray.prototype);
    }
}

export class LiveHubBrowseRegistryResponse {
    CurrentPage: number;
    LicenseKey: string;
    RequestorID: string;
    RootString: string;
    SubKey: string;
    SubKeys: RegistrySubKeyItemArray;
    TotalPageCount: number;
    Values: RegistryValueItemArray;
}

export class LiveHubRegistryResponse {
    DateTime: Date;
    Result: boolean;
    Message: string;
    LicenseKey: string;
    Value: string;
}
